import React from 'react';
import Logo from '../assets/imges/Whitefriar-global-logo-1024x198.png';

const Home = () => {
        return (
		<div
			style={{
				minHeight: '100vh',
				height: '100vh',
				width: '100vw',
				background: '#ffffff',
				display: 'flex',
				alignItems: 'center',
				justifyContent: 'center',
				overflow: 'hidden'
			}}
		>
			<img
				src={Logo}
				alt="Whitefriar"
				style={{
					maxWidth: '70vw',
					maxHeight: '40vh',
					height: 'auto',
					width: 'auto',
					objectFit: 'contain'
				}}
			/>
                </div>
    );
};

export default Home;
